import React from "react";
import { AccountSecurity } from "@/components/settings/AccountSecurity";

// Security is identical for every role — one shared component.
export function SecurityTenant() {
  return <AccountSecurity />;
}
